var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"canvas-container"},[_c('Canvas-3d',{attrs:{"defaultFrontModel":"OV-492","defaultTemplesColor":"PL0001","defaultFrontColor":"PL0001","defaultSunLenses":"PRO0000773","shouldLoadScene":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }